<template>
    <div>
        <div class='contents'>
            <section class="hero is-light is-fullheight">
                <div class="hero-body">
                    <div class="container">
                        <div class="columns is-centered">
                            <div class="column is-5-tablet is-4-desktop is-4-widescreen">
                                <form action="" class="box">
                                    <div class="field">
                                        <label for="" class="label">メールアドレス</label>
                                        <div class="control has-icons-left">
                                            <input v-model='email' type="email" class="input" required>
                                            <span class='icon is-small is-left'>
                                                <i class='fas fa-envelope'></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <label for="" class="label">パスワード</label>
                                        <div class="control has-icons-left">
                                            <input v-model='password' type="password" class="input" required>
                                            <span class="icon is-small is-left">
                                                <i class="fa fa-lock"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <router-link to="/forgot"><p class='link'>パスワードを忘れた場合</p></router-link>
                                    <div class="field">
                                        <div class="button is-success login" @click='login'>
                                            ログイン
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LoginPage',
    components: {
    },
    data () {
        return {
            email: '',
            password: ''
        }
    },
    mounted () {
    },
    methods: {
        login () {
            const self = this
            self.axios.post(`${process.env.API_URL}/login`, {
                email: self.email,
                password: self.password
            }).then((res) => {
                const type = res.data.type

                if (res.data.message !== 'OK') {
                    alert('メールアドレスまたはパスワードが間違っています')
                    return
                }

                if (type === 'admin') {
                    self.$router.push('/admin')
                } else if (type === 'lab') {
                    self.$router.push('/lab')
                } else if (type === 'photographer') {
                    self.$router.push('/photographer')
                } else {
                    self.$router.push('/photobuy/mypage')
                }
            }).catch((e) => {
                alert('サーバーに問題が発生しています')
            })
        }
    }
}
</script>

<style scoped>
.login {
    margin-top: 30px;
    width: 100%;
}

.link {
    color: #1a0dab;
}
</style>



// WEBPACK FOOTER //
// src/routes/LoginPage.vue